import React, { useState } from 'react'
import HomeIcons from './HomeIcons'
import ModalComments from './ModalComments'
import TitleBody from './TitleBody'
import TitleIcons from './TitleIcons'

export default function AddPost() {
    const [post,setPost] = useState("")
    const addPostIcon = [
        {key : 1,name: "Write a post" , icon:"fa-solid fa-pen-to-square",classname:"w-[40px] h-[40px] leading-[40px] bg-[#FFEE93] rounded-3xl",link:""},
        {key : 2,name: "Upload photo" , icon:"fa-regular fa-image",classname:"w-[40px] h-[40px] leading-[40px] bg-[#FFEE93] rounded-3xl",link:""},
        {key : 3,name: "Upload video" , icon:"fa-solid fa-circle-play",classname:"w-[40px] h-[40px] leading-[40px] bg-[#FFEE93] rounded-3xl ",link:""}
    ]
  return (
      <main className=" w-full md:w-[98%]  flex items-center justify-center mt-4 px-5">
        
                <div className="border max-w-screen-md bg-white mt-6 rounded-lg p-4 w-full ">
                    <TitleIcons Usericon={addPostIcon} classlist="flex-row w-full gap-2 sm:gap-10 flex-wrap py-0" />
                    <div className="mt-5 border-b-2 mb-5"></div>
                    <div className=" h-12 md:h-20 border-b  flex items-center justify-around bgHome px-5 overflow-hidden rounded-lg pt-3 md:pt-4 focus-within:shadow-[1px_1px_7px_3px_#A9DEF9]  ">
                       {post===""?<i className='fa-solid fa-pen-to-square pb-3 md:pb-10 pr-2 text-gray-400 '></i>:null} 
                        <textarea placeholder="Write something here..." className='scrollbar bg-transparent w-full h-full outline-none  resize-none overflow-y-scroll 'onChange={(event)=>{setPost(event.target.value)}} />
                        
                    </div>
                </div>
            </main>
  )
}
